module.exports = __webpack_public_path__ + "static/media/introduce.f99ad868.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S厢式车/introduce.png
// module id = 719
// module chunks = 0